import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LoginComponent } from './pages/login/login.component'
import { SignupComponent } from './pages/signup/signup.component'
import { AuthGuard } from './guards/auth.guard'
import { LeavePageGuard } from './guards/leave-page/leave-page.guard'
import { VirtualEchargerComponent } from './pages/echargers/virtual-echarger/virtual-echarger.component'
import { SearchSiteComponent } from './pages/sites/search-site/search-site.component'
import { CreateSiteComponent } from './pages/sites/create-site/create-site.component'
import { CreateZoneComponent } from './pages/sites/create-site/create-zone/create-zone.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'create-zone',
    component: CreateZoneComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'create-site',
    component: CreateSiteComponent,
    canActivate: [ AuthGuard ],
    canDeactivate: [ LeavePageGuard ]
  },
  {
    path: 'update-site/:_id',
    component: CreateSiteComponent,
    canActivate: [ AuthGuard ],
    canDeactivate: [ LeavePageGuard ]
  },
  {
    path: 'search-site',
    component: SearchSiteComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'virtual-echarger',
    component: VirtualEchargerComponent,
    canActivate: [ AuthGuard ]
  },
  { path: '**', redirectTo: '/login' }
]

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }
